declare global {
  interface Window {
    REACT_APP_API_HOST: any;
    REACT_APP_API_SIGNAL_HOST: any;
    REACT_APP_EXPORT_PARAMETERS: any;
    REACT_APP_GEOSERVER_PROPERTY_NAME: any;
    REACT_APP_TOKEN_KEY: any;
    REACT_APP_ZEUS_CONTRACT: any;
    REACT_APP_MERCURE_API_URL: any;
  }
}

const apiUrl = window.REACT_APP_API_SIGNAL_HOST || process.env.REACT_APP_API_SIGNAL_HOST || window.REACT_APP_API_HOST || process.env.REACT_APP_API_HOST;
const apiExportParameters = window.REACT_APP_EXPORT_PARAMETERS || process.env.REACT_APP_EXPORT_PARAMETERS || '';
const geoserverPropertyName = window.REACT_APP_GEOSERVER_PROPERTY_NAME || process.env.REACT_APP_GEOSERVER_PROPERTY_NAME || '';
const tokenKey = window.REACT_APP_TOKEN_KEY || process.env.REACT_APP_TOKEN_KEY || '';
const zeusContract =  window.REACT_APP_ZEUS_CONTRACT || process.env.REACT_APP_ZEUS_CONTRACT;
const mercureApiUrl = window.REACT_APP_MERCURE_API_URL || process.env.REACT_APP_MERCURE_API_URL || '';

// use process.env in dev instead window
export const config = {
  apiUrl: apiUrl,
  apiExportParameters: apiExportParameters,
  geoserverPropertyName: geoserverPropertyName,
  tokenKey: tokenKey,
  zeusContract: zeusContract,
  mercureApiUrl: mercureApiUrl,
};
